import { Component } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { MultiButtonInput } from '../../../../components'
import { LightGreyText, MobileFullWidthContainer } from '../../styled'

const Question = styled.div`
  margin-top: 25px;
`

/* The question sits on its own row, with the toggle beneath it. */
const Label = styled.div`
  margin-bottom: 8px;
`
const TAX_TYPES_TEXT = {
  0: 'Not Invested',
  1: 'pre-tax',
  2: 'after-tax',
  5: 'Roth',
}

class AddBalanceButtons extends Component {
  static displayName = 'AddBalanceButtons'
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    taxType: PropTypes.number.isRequired,
  }

  render() {
    const { onChange, taxType } = this.props

    return (
      <Question>
        <Label>
          <LightGreyText>{`Add to ${TAX_TYPES_TEXT[taxType]} balance?`}</LightGreyText>
        </Label>
        <MobileFullWidthContainer>
          <MultiButtonInput
            mobileToggle
            name='participantId' // no idea why this has the name participantId
            value={this.props.value}
            onChange={(name, value) => onChange(name, value, taxType)}
            buttons={[
              { text: 'Yes', value: taxType },
              { text: 'No', value: false },
            ]}
          />
        </MobileFullWidthContainer>
      </Question>
    )
  }
}

export default AddBalanceButtons
